<style lang="less">
    @import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;">
        <div class="table-list" style="height:auto;min-height: 726px">
            <div class="table-list-title">
                <span style="margin-left:25px">我的保险</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker @on-change="changeDate" :value="value2" format="yyyy-MM-dd" type="daterange"
                                 placement="bottom-end" placeholder="选择日期" style="width: 200px"></Date-picker>
                    <div class="father-box-input">
                        <input placeholder="请输入作品名称" v-model="name" class="select-input-self"
                               @keyup.enter="addworkname"></input>
                        <img @click="addworkname" src="@/assets/search.png" class="search-icon" alt='版权登记'/>
                    </div>
                    <button @click="addworkname" class="btn-84" style="margin-right:30px">查询</button>
                </div>
            </div>
            <div class="caozuo-box">
                <button class="btn" @click="openModal">选择作品上保险</button>
                <img src="./images/wenhao.png" style="width:16px;height:16px;cursor: pointer;" @click="goInsurance" alt='版权登记'/>
                <!-- <button class="xuqi_btn" @click="openModal">保险续期</button> -->
            </div>
            <Row class="table-style-size">
                <!-- <i-col span="2">选择</i-col> -->
                <i-col span="6">保单编号</i-col>
                <i-col span="2">投保作品</i-col>
                <i-col span="2">确权方式</i-col>
                <i-col span="3">被保险人</i-col>
                <i-col span="3">创建时间</i-col>
                <i-col span="2">保险起期</i-col>
                <i-col span="2">保险止期</i-col>
                <i-col span="2">状态</i-col>
                <i-col span="2">电子发票</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">
                    <!-- <i-col span="2">
                        <img :src="currentIndex==index?yes:no" class="imgbox" @click="selectItem(index,item.id)" />
                    </i-col> -->
                    <i-col span="6">
                        <!-- <img src='./images/baoxianlog.png' style="width:16px;height:16px;" v-if="item.insuranceStatus == 1"/> -->
                        <a v-if="item.insuranceStatus == 1 && (item.policyUrl ==null || item.policyUrl =='')" @click="downLoadInvoice(item)" style="color:#F7B500">{{item.policyNo}}<img src='./images/baoxianlog.png' style="width:16px;height:16px;" v-if="item.insuranceStatus == 1"/></a>
                        <a v-if="item.insuranceStatus == 1 && item.policyUrl !=null && item.policyUrl !=''"  @click="downLoad(item.policyUrl)" style="color:#F7B500">{{item.policyNo}}<img src='./images/baoxianlog.png' style="width:16px;height:16px;" v-if="item.insuranceStatus == 1"/></a>
                    </i-col>
                    <i-col span="2">
                        <!-- <router-link :to="'/copyrightDetails?id=' + item.refSeqNo" 
                                style="color:#F7B500">
                        </router-link> -->
                        <span v-if="item.type == 0" style="color:#F7B500;cursor: pointer;" @click="goDciDetail(item)">{{item.registerWorksName}}</span>
                        <span v-else style="color:#F7B500;cursor: pointer;" @click="goDetail(item)">{{item.registerWorksName}}</span>
                    </i-col>
                    <i-col span="2">{{item.type == 1 ? "存证":"登记"}}</i-col>
                    <i-col span="3">{{item.insuredPerson}}</i-col>
                    <i-col span="3">{{item.createDate}}</i-col>
                     <i-col span="2">{{item.startDate && item.startDate.split(" ")[0]}}</i-col>
                    <i-col span="2">{{item.endDate && item.endDate.split(" ")[0]}}</i-col>
                    <i-col span="2">
                        <a v-if="item.insuranceStatus == 0" style="color:#F7B500" @click="shangbaoxian(item)">未承保</a>
                        <span v-else>已承保</span></i-col>
                    <i-col span="2">
                        <a v-if="item.insuranceStatus == 1 && (item.invoiceUrl ==null || item.invoiceUrl =='')" @click="downLoadInvoice(item)" style="color:#F7B500">下载</a>
                        <a v-if="item.insuranceStatus == 1 && item.invoiceUrl !=null && item.invoiceUrl !=''"  @click="downLoad(item.invoiceUrl)" style="color:#F7B500">下载</a>
                        <a v-if="item.insuranceStatus == 0" style="cursor: not-allowed;color: #ccc;">下载</a>
                    </i-col>
                </Row>
                <div class="commont-page"
                     style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total"
                          size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>
            <div class="empty-box" v-if="records.length<=0&&flag">
                <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>
        </div>
        <!-- 选择作品上 保险 -->
        <insurance @fatherModal="fatherModal" @refSeqNo ="getRefSeqNo" @updateBillData="resetData" v-if="showModal" ref="childModal"></insurance>
        <!-- 是否支付成功 -->
        <paySuccess @fatherModal="payModal" :msg-val="orderSeqNoChild" :msg-type="insuranceType" v-if="isShowPayModal" ref="payChildModal"></paySuccess>
    </div>

</template>

<script>
    import insurance from './insuranceModel';
    import paySuccess from './insurancePay';
    import {getOrderDownCert, getCertFileType,getInsurance,getInvioceInsurance,getInsuranceUrl} from '@/api/staticPage';
    import {_downloadEnc, _generateEncByOrderCommon} from '@/api/notarization'
    import Cookies from "js-cookie";
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe.vue'
    import payWay from '@/views/main-components/pay-way';


    export default {
        metaInfo: {
            title: '我的保险|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '我的存证,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'myInsurance',
        components: {
            generalframe,
            payWay,
            insurance,
            paySuccess
        },
        data() {
            return {
                isShowPayModal:false,
                total: 0,
                pageSize: 8,
                pageNumber: 1,
                startDate: '',
                endDate: '',
                name: '',
                attachementsTypes: '',
                value2: [],
                model1: 'all',
                records: [],
                ifDciSuccess: require('@/assets/cert-open.png'),
                ifFciFail: require('@/assets/cert-close.png'),
                ifNotarizationSuccess: require('@/assets/notarization_active.png'),
                ifNotarizationFail: require('@/assets/notarization.png'),
                flag: false,
                pages: 0,
                flagType: 0,
                showDialog: false,
                payWay: null,
                disabled: false,
                PayWayCom: 'payWay',
                applyNotarizationNum: '',
                currentIndex:null,
                yes: require('./images/yes.png'),
                no:require("./images/no.png"),
                billId:"",
                showModal:false,
                orderSeqNoChild:"",
                insuranceType:0
            }
        },
        methods: {
            //为城堡上保险
            shangbaoxian(a){
                let data = {
                    refSeqNo:a.refSeqNo,
                    type:a.type
                }
                getInsuranceUrl(data).then(res=>{
                    if(res.code == 200){
                        window.open(res.result)
                        this.isShowPayModal = true;
                        this.orderSeqNoChild = a.refSeqNo;
                        this.insuranceType = a.type;
                    }else{
                        toast(res.message)
                    }
                })
            },
            //去详情
            goDetail(data){
                window.open('/cert-info?id=' + data.refSeqNo, '_blank')
                // this.$router.push({
                //     path: '/cert-info',
                //     query: {
                //         id:data.refSeqNo
                //     }
                // })
            },
            //去登记详情
            goDciDetail(data){
                window.open('/copyrightDetails?id=' + data.refSeqNo, '_blank')
                // this.$router.push({
                //     path: '/copyrightDetails',
                //     query: {
                //         id:data.refSeqNo
                //     }
                // })
            },
            //去了解上保险险情
            goInsurance(){
                this.$router.push({
                    path:'/insurance'
                })
            },
            //下载
            downLoad(data){
                window.open(data, '_blank')
            },
            //下载电子发票
            downLoadInvoice(data){
                console.log()
                getInvioceInsurance(data.orderSeqNo).then(res=>{
                    if(res.code == 200){
                        window.open(res.result, '_blank')
                    }else{
                        toast(res.message)
                    }
                })
            },
            //购买保险
            openModal() {
                this.showModal = true
            },
            //单选
            selectItem(index,id){
                this.currentIndex=index
                this.billId=id
            },
            fatherModal() {
                this.showModal = false;
                this.isShowPayModal = true;
            },
            payModal() {
                this.isShowPayModal = false;
                this._getInsurance();
            },
            getRefSeqNo(orderSeqNo,type){
                this.orderSeqNoChild = orderSeqNo;
                this.insuranceType = type;
                console.log(orderSeqNo)
                console.log(type)
            },
            //重置数据
            resetData() {
                this.total = 0;
                this.pages = 0;
                this.pageNumber = 1;
                this.records = [];
                this._getInsurance();
                // this.getFindPage();
            },
            _getInsurance() {
                let _this = this;
                _this.$Spin.show();
                let userInfo = JSON.parse(Cookies.get("userInfo"));
                let params = {
                    pageNumber: _this.pageNumber,
                    pageSize: _this.pageSize,
                    // sort: 'create_date',
                    // order: 'desc',
                    queryStartDate: _this.startDate,
                    queryEndDate: _this.endDate,
                    keyword: _this.name,
                    // attachementsTypes: _this.attachementsTypes,
                    // registerId: userInfo && userInfo.id ? userInfo.id : '',
                }
                getInsurance(params).then((res) => {
                    console.log('获取的最后的实名状态', res)
                    if (res.code == 200) {
                        _this.$Spin.hide();
                        _this.records = res.result.records
                        if(Number(res.result.total)>0){
                            _this.total = Number(res.result.total)
                        }else{
                            _this.total = 0
                        }
                        
                        _this.flag = true;
                        _this.pages = res.result.pages
                    }else{
                        _this.$Spin.hide();
                        toast(res.message)
                    }
                })
            },
            changeDate(starttime, endtime) {
                this.startDate = starttime ? starttime[0] : '';
                this.endDate = starttime ? starttime[1] : '';
                this.pageNumber = 1;
                this._getInsurance();
            },
            changepage(index) {
                this.pageNumber = index
                this._getInsurance();
            },
            addworkname() {
                this.pageNumber = 1;
                this._getInsurance();
            },
        },
        mounted() {
            this._getInsurance();
        }
    }
</script>

<style scoped lang="less">
.imgbox{
    width: 16px;
    height: 16px;
}
    .showphotow {
        display: inline-block;
        height: 100%;
        position: relative;

        .showdiasy {
            position: absolute;
            top: 35px;
            left: 0px;
            background: #fff;
            box-shadow: 0 2px 18px 0 rgba(179, 189, 199, .47);
            border-radius: 4px;
            z-index: 777;
            width: 110px;
            display: none;

            p {
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                font-size: 12px;
                background-color: #fff;
                color: #929292;
            }

            p:hover {
                background-color: #f7f9fb;
                color: #4e4e4e;
            }
        }

        &:hover {
            .showdiasy {
                display: block;
            }
        }
    }

    .notarization_icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 8px;
    }

    .submit-button {
        width: 230px;
        height: 42px;
        background: rgba(255, 216, 0, 1);
        border-radius: 4px;
        line-height: 42px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
        cursor: pointer;
        border: none;
        outline: none;
    }
.caozuo-box{
    margin-bottom: 12px;
    background: #fff;
    display:flex;
    flex-direction:row;
    align-items:center;
    .btn{
        width: 120px;
        height: 33px;
        background: rgba(255,216,0,0.05000000074505806);
        border: 1px solid #ffd800;
        border-radius: 2px;
        font-size: 12px;
        color: #f7b500;
        text-align: center;
        line-height: 33px;
        margin-left: 20px;
        margin-right: 10px;
        cursor: pointer;
        border: none;
        outline: none;
    }
    .xuqi_btn{
        width: 84px;
        height: 33px;
        background: #ffd800;
        border: 1px solid #ffd800;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        line-height: 33px;
        text-align: center;
        margin-left: 36px;
        cursor: pointer;
        border: none;
        outline: none;
    }
}
</style>